import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Dropdown } from 'semantic-ui-react';

import ImageSliderAutoAdvanceCheckbox
  from 'components/dashboard/image-slider/ImageSliderAutoAdvanceCheckbox';
import ImageSliderDemandSelector
  from 'components/dashboard/image-slider/ImageSliderDemandSelector';

import './ImageSliderShapeSize.css';

class ImageSliderShapeSize extends Component {
  static propTypes = {
    patchImageSlider: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
  };

  static defaultProps = {

  };

  state = {
    currentShapeSize: null,
    currentPerRow: null,
  };

  componentDidMount() {
    this.setState({ currentShapeSize: this.props.item.image_size });
    this.setState({ currentPerRow: this.props.item.items_per_row });
  }

  render() {
    const { item, patchImageSlider } = this.props;

    const shapeSizeOptions = [
      {
        key: 'SQ',
        text: i18n.t("Square 1:1 (Width:Height)"),
        value: 'SQ',
      },
      {
        key: 'HR',
        text: i18n.t("Landscape 4:3 (Width:Height)"),
        value: 'HR',
      },
      {
        key: 'VR',
        text: i18n.t("Vertical 3:4 (Width:Height)"),
        value: 'VR',
      },
    ];

    const perRowOptions = [
      {
        key: 1,
        text: i18n.t("1 item per Row"),
        value: 1,
      },
      {
        key: 2,
        text: i18n.t("2 items per Row"),
        value: 2,
      },
      {
        key: 3,
        text: i18n.t("3 items per Row"),
        value: 3,
      },
    ];

    return (
      <div className="image-slider-shape-size__component">
        <div className="dropdown-wrapper">
          <div className="label">{i18n.t("Image Shape & Size")}</div>
          <Dropdown
            fluid
            selection
            value={this.state.currentShapeSize}
            options={shapeSizeOptions}
            onChange={(_e, data) => {
              this.setState({ currentShapeSize: data.value });
              patchImageSlider(item.id, { image_size: data.value });
            }}
          />
        </div>

        {item.display_type !== 'show_as_slider' &&
          <div className="dropdown-wrapper">
          <div className="label">{i18n.t("Items Per Row")}</div>
          <Dropdown
            fluid
            selection
            value={this.state.currentPerRow}
            options={perRowOptions}
            onChange={(_e, data) => {
              this.setState({ currentPerRow: data.value });
              patchImageSlider(item.id, { items_per_row: data.value });
            }}
          />
        </div>}

        <div className="auto-advance">
          <ImageSliderAutoAdvanceCheckbox
            sliderItem={item}
            isAutoAdvance={item.is_auto_advance}
          />
        </div>

        {item.is_auto_advance &&
          <div className="demand-selector">
            <ImageSliderDemandSelector item={item} />
          </div>
        }
      </div>
    );
  }
}

export default connect(
  null,
  {
    patchImageSlider,
  },
)(ImageSliderShapeSize);
